class ScrollFade {
	constructor(el) {
		this.el = el

		this.fadeEl = this.el.querySelectorAll('[data-role="js--scroll-fade-element"]')[0];
		this.fadeMedia = this.el.querySelectorAll('[data-role="js--scroll-fade-media"]')[0];
		this.positiveMotion = this.fadeMedia.dataset.positivemotion;


		window.addEventListener('scroll', function(event) {
			let containerHeight = this.el.clientHeight,
				bodyHeight = document.body.clientHeight,
				scrollTop = window.pageYOffset || document.documentElement.scrollTop,
				heroAmountInView = 1-scrollTop/containerHeight, // int 1-0, 1 === hero is in view, 0 === scrolled past hero
				topAdjust = -(heroAmountInView*(containerHeight/2)-containerHeight/2),
				mediaAdjust = ((heroAmountInView - 1) * -200),
				opacityAdjust = Math.max(Math.min(Math.pow(heroAmountInView,2),1),0); //power to increase movement speed

				// this.fadeEl.setAttribute('style', 'position:relative;transform: translateY('+topAdjust+'px);opacity:'+opacityAdjust+';');
			this.fadeEl.style.position = 'relative';
			this.fadeEl.style.transform = 'translateY('+topAdjust+'px)';
			this.fadeEl.style.opacity = opacityAdjust;

			// this.fadeMedia.setAttribute('style', 'margin-top: -'+topAdjust+'px;'); //top and transform are reserved for element positioning
			// console.log("this.dataPositiveMotion",this.dataPositiveMotion)
			if (this.positiveMotion) {
				this.fadeMedia.style.marginTop = mediaAdjust+'px'; //top and transform are reserved for element positioning
				// this.fadeMedia.style.marginTop = topAdjust+'px'; // !note topAdjust works quite well, instead of mediaAdjust
			}
			else {
				this.fadeMedia.style.marginTop = -mediaAdjust+'px'; //top and transform are reserved for element positioning
				// this.fadeMedia.style.marginTop = -topAdjust + 'px'; // !note topAdjust works quite well, instead of mediaAdjust
			}

		}.bind(this));
	}
}

export default ScrollFade







